<template>
    <div class="form-group" :class="{ row : isOnModeLabelOnLeft }">
      <label
        v-if="label"
        :title="titleComputed"
        :for="idComputed"
        :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
        class="text-truncate"
        >{{label}} <small v-if="required">*</small></label>
        <div
          :class="{ 'col-sm-10': isOnModeLabelOnLeft }"
          @keyup.enter="enter"
          >
          <v-selectpage
            tabindex="0"
            class="text-truncate"
            ref="vSelectpage"
            :key-field="keyField"
            :disabled="disabled"
            :class="{'selectpage-error': v.$error}"
            :data="data"
            :pageSize="pageSize"
            :multiple="multiple"
            :language="language"
            :title="title"
            v-model="model"
            :tb-columns="tbColumns"
            :placeholder="placeholder"
            @values="$emit('values', $event)"
            @removed="$emit('removed', $event)"
            />
          <p class="invalid-feedback d-block" v-if="!v.required && v.$error"> {{ $t('field_required')}} </p>
        </div>
    </div>
</template>

<script>
import { SelectPage } from 'v-selectpage'
import lmInputMixin from '@/mixins/lmInputMixin.js'

export default {
  mixins: [lmInputMixin],
  components: {
    'v-selectpage': SelectPage
  },
  props: {
    keyField: {
      type: String,
      default: 'id'
    },
    tbColumns: {
      type: Array,
      default: () => []
    },
    language: {
      type: String,
      default: 'es'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    pageSize: {
      type: Number,
      default: 10
    },
    /**
     * Data
    */
    data: {
      type: [String, Array],
      default: ''
    },
    model: {
      type: String,
      default: ''
    }
  },
  methods: {
    enter () {
      this.$refs.vSelectpage.$refs.drop.visible()
      this.$on('values', function () {
        setTimeout(() => {
          this.$refs.vSelectpage.$el.focus()
        }, 1000)
      })
    },
    remove () {
      this.$refs.vSelectpage.remove()
    }
  }
}
</script>

<style lang="sass">
.selectpage-error
  .sp-input-container
    .sp-inputs,
    .sp-input
      border: 1px solid red !important
.sp-base
  min-height: 38px !important
.sp-input
  span
    display: block !important
    overflow: hidden
    padding-right: 35px !important
    text-overflow: ellipsis
</style>
